var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E65D25;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#168FBC;}\n\t.st3{fill:#BA2227;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0.58,82.22 11.74,20.38 75.15,20.38 64.1,82.22  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.66,38.02l-9.71,13.06h14.74L41.66,38.02z M59.18,62.02L57.17,72.4l-1.79,1l-6.14-15.07H27.7L15.87,73.52 h-9.6l37.62-49.34L59.18,62.02z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "55.39,73.52 66.44,11.67 129.96,11.67 118.8,73.52  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.68,34.33h-9.82c-1.67-3.8-4.58-7.59-12.39-7.59c-5.47,0-10.05,2.23-13.73,6.59 c-2.9,3.46-4.58,7.37-4.91,11.5s0.89,7.7,3.46,10.49c2.57,2.79,5.92,4.24,9.94,4.24c3.01,0,5.8-0.78,8.37-2.23s4.8-3.68,6.59-6.59 H92.9l1.67-7.26H116c-0.89,7.81-3.68,12.95-8.6,17.53c-4.8,4.58-10.83,6.81-17.75,6.81c-7.59,0-13.4-2.68-17.41-7.93 C69,55.65,67.66,50.62,68,44.71c0.45-7.14,3.46-13.28,9.04-18.53c5.47-5.25,11.83-7.81,18.98-7.81c2.68,0,5.25,0.33,7.7,1.12 c2.46,0.78,5.8,2.57,7.93,4.47C114.44,26.63,116.68,30.31,117.68,34.33z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "55.39,73.52 64.1,82.22 65.66,73.52  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAg);
export default __webpack_public_path__ + "static/media/ag.8bc67662f3b66bee69f6bc8ea48c2ab8.svg";
export { ForwardRef as ReactComponent };